/**
 * serialize.js
 */
export default function (obj, separator = '&') {
  return Object.keys(obj)
    .reduce((acc, key) => {
      const objValue = obj[key]

      if (Array.isArray(objValue)) {
        objValue.forEach((value, index) => {
          acc.push(`${key}[${index}]=${value}`)
        })
      } else {
        acc.push(`${key}=${objValue}`)
      }

      return acc
    }, [])
    .join(separator)
}



// WEBPACK FOOTER //
// ./src/helpers/serialize.js